export default __webpack_public_path__ + "static/media/antioxidants.7a61afdf.svg";